module.exports = __webpack_public_path__ + "media/lead_gen_offers/ncsa-a1cc678a.png";